import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as queryString from 'query-string'

import { Header, Main, Offer, Footer } from '../../components/discount'

import { QueryHandler } from '../sale/handlers'
import { Modal } from '../../components/sale/index'
import { ampEvent } from '../../utils/amplitude'
import {
	getIsLegalFlow,
	getIsOnlyLegalFlow,
	setInitialPrice,
	setIsLegalFlow,
	setIsRedirectingToLegal,
	setProductId,
	setPurchaseType,
	setTotalPrice,
} from '../../redux/slices/userSlice'
import { offersList } from './offersList'
import { paramsToQuery } from '../../utils/historyDecorators'

import './styles.scss'

const Discount = () => {
	const [isActive, setIsActive] = useState(false)
	const [isActiveModal, setIsActiveModal] = useState(false)
	const { search, pathname } = useLocation()
	const params = queryString.parse(location.search)
	const history = useHistory()
	const dispatch = useDispatch()

	const isLegalFlow = useSelector(getIsLegalFlow)
	const isOnlyLegalFlow = useSelector(getIsOnlyLegalFlow)

	const [offers, setOffers] = useState(offersList)
	const selectedOffer = offers.find(offer => offer.isSelected)

	const handleSelectOffer = id =>
		setOffers(
			offers.map(offer => {
				if (offer.id === id) {
					offer.isSelected = true
					return offer
				}

				offer.isSelected = false
				return offer
			}),
		)

	useEffect(() => {
		if (pathname === '/discount11') {
			dispatch(setIsLegalFlow({ isLegalFlow: false }))
		} else {
			dispatch(setIsLegalFlow({ isLegalFlow: true }))
		}

		setTimeout(() => {
			ampEvent('Discount_screen_shown')
		}, 100)

		setTimeout(() => {
			setIsActive(true)
		}, 350)
		QueryHandler(search, {
			setIsActiveModal: setIsActiveModal,
			dispatch,
		})
	}, [])

	useEffect(() => {
		dispatch(setTotalPrice({ totalPrice: selectedOffer?.price }))
		dispatch(
			setProductId({
				productId: isLegalFlow
					? selectedOffer?.productId
					: process.env.REACT_APP_NEW_INITIAL_DISCOUNT_PRODUCT_ID,
			}),
		)
		dispatch(
			setPurchaseType({
				purchaseType: selectedOffer?.type,
			}),
		)
		dispatch(
			setInitialPrice({
				initialPrice: isLegalFlow ? '0.69' : '0.10',
			}),
		)
	}, [selectedOffer])

	useEffect(() => {
		if (isOnlyLegalFlow && pathname.includes('/discount11')) {
			dispatch(setIsRedirectingToLegal({ isRedirectingToLegal: true }))
			history.push({
				pathname: '/discount',
				search: paramsToQuery(params),
			})
		}
	}, [isOnlyLegalFlow])

	return (
		<div className={`discount ${isActive ? 'discount--active' : ''}`}>
			<Header setIsActiveModal={setIsActiveModal} />
			{!isLegalFlow && <Main />}
			<Offer
				selectedOffer={selectedOffer}
				offers={offers}
				handleSelectOffer={handleSelectOffer}
				setIsActiveModal={setIsActiveModal}
			/>
			<Footer />
			<Modal
				setIsActiveModal={setIsActiveModal}
				isActiveModal={isActiveModal}
				total={isLegalFlow ? '0.69' : '0.10'}
				annualPlan={isLegalFlow ? selectedOffer.price : 6.99}
				discount={6.99}
				product_id={
					isLegalFlow
						? selectedOffer.productId
						: process.env.REACT_APP_NEW_INITIAL_DISCOUNT_PRODUCT_ID
				}
			/>
		</div>
	)
}

export default Discount
